import * as yup from 'yup';

export const userRecoveryPassword = yup.object({
  username: yup.string().required('Username es requerido').email('Correo electrónico inválido')
  
});